import { formatPercent } from '@angular/common';
import { number } from 'echarts';

// echarts 默认只支持按 value 大小显示面积，可以自行对 value 做映射，让 value 很小的 node 也显示出来
export const convertTreemapData = (data: { name: string; value: number }[]) => {
    let sum = 0;
    let max = 0;

    for (const item of data) {
        sum += item.value;
        max = Math.max(max, item.value);
    }

    return data.map(item => {
        const visualValue = number.linearMap(item.value, [0, max], [30, 200]);
        return {
            name: item.name,
            value: visualValue,
            realValue: item.value,
            percent: formatPercent(item.value / sum, 'en-us', '1.0-2'),
        };
    });
};
